import { GDC_CODES, GDC_CODES_FALLBACK } from './GDC_CODES';
var cutomGDC_CODES = ['GUSD', 'DIA', 'GDKK', 'GSEK', 'GGBP', 'CRED'];
/**
 * cut to 2 maximum digits
 * @param value
 */
function digitsCut(value) {
    var lengthToCut = value.length - parseFloat(value).toFixed(2).length;
    if (lengthToCut > 0) {
        return value.slice(0, lengthToCut * -1);
    }
    return value;
}
function convertValue(value, gdc) {
    var v = parseFloat(digitsCut('' + value));
    return v * GDC_CODES[gdc].factor;
}
function checkIfBrowserSupportsIntl(locales) {
    var supportsLocale = !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function'), supportedLocaleList;
    if (supportsLocale) {
        supportsLocale = false;
        supportedLocaleList = Intl.NumberFormat.supportedLocalesOf(locales);
        for (var i = 0; i < locales.length; i++) {
            if (supportedLocaleList.indexOf(locales[i]) !== -1) {
                supportsLocale = true;
            }
        }
    }
    return supportsLocale;
}
function getDelemitter(locale) {
    return (1.1).toLocaleString(locale).split('1')[1];
}
function handlePrimitivFormatting(value, gdc) {
    var delemitter = getDelemitter(GDC_CODES[gdc].locale);
    var n = GDC_CODES[gdc].factor === 100 ? parseInt('' + value) : parseFloat('' + value);
    var v = n.toLocaleString(GDC_CODES[gdc].locale);
    if (GDC_CODES[gdc].factor === 1) {
        if (v.indexOf(delemitter) === -1) {
            // no delemitter
            v += delemitter + "00";
        }
        else {
            // make sure we have only 2 digits
            var split = v.split(delemitter);
            if (split[1].length < 2) {
                v += '0';
            }
            else if (split[1].length > 2) {
                v = split[0] + delemitter + split[1].slice(0, 2);
            }
        }
    }
    return GDC_CODES_FALLBACK[gdc].exp.replace('{num}', '' + v);
}
export default function convert(value, obj) {
    if (!obj)
        throw new Error('Missing second argument');
    if (!obj.gdc)
        throw new Error('Missing gdc property in second argument');
    if (obj.locale === undefined)
        obj.locale = GDC_CODES[obj.gdc].locale;
    if (checkIfBrowserSupportsIntl([obj.locale])) {
        if (cutomGDC_CODES.indexOf(obj.gdc) !== -1) {
            // DIA and CRED are rendered as "currencyDisplay: 'name'" - this is in all languages
            var intl = new Intl.NumberFormat(obj.locale, {
                style: 'currency',
                currency: 'EUR',
                currencyDisplay: obj.gdc === 'DIA' || obj.gdc === 'CRED' ? 'name' : 'symbol',
                minimumFractionDigits: GDC_CODES[obj.gdc].digits,
                maximumFractionDigits: GDC_CODES[obj.gdc].digits,
            });
            return (intl
                .format(convertValue(value, obj.gdc))
                .replace(/€|EUR|euros|Euro|euro/, GDC_CODES[obj.gdc].symbol)
                .replace(' ', '\u00A0')
                // cut digits - thanks to edge which has a bug which ignores
                // the minimumFractionDigits https://github.com/microsoft/ChakraCore/issues/6029
                //...so lets cut everything after the delemitter which is a number
                .replace(GDC_CODES[obj.gdc].digits === 0 ? new RegExp("\\" + getDelemitter(obj.locale) + "[0-9]*") : '', ''));
        }
        else {
            var intl = new Intl.NumberFormat(obj.locale, { style: 'currency', currency: obj.gdc });
            return intl.format(convertValue(value, obj.gdc));
        }
    }
    else {
        // fallback handler
        // TODO:jslog if we still need support this
        return handlePrimitivFormatting(convertValue(value, obj.gdc), obj.gdc);
    }
}
//# sourceMappingURL=converter.js.map